export default {
    activityList: '/cmy/cmyactivity/activity/listActivityByMonth', //活动列表
    activityInfo:'/cmy/cmyactivity/activity/get',//获取单个活动详情
    publishActivity:'/cmy/cmyactivity/activity/publishActivity',//发布活动
    addACctivity: '/cmy/cmyactivity/activity/saveActivity', //添加活动
    uploadImg:'/cmy/sendArticleManager/uploadMaterial_base64.ht', //上传图片
    typeList:'/cmy/cmyactivity/activityType/listTypeAndActivityCount', //获取分类列表
    addType:'/cmy/cmyactivity/activityType/save', //添加分类
    delType:'/cmy/cmyactivity/activityType/del', //删除分类
    getRecruitsDetail:'/cmy/cmyactivity/activityRecruitsDetail/list',//查看招募详情
    activitySign:'/cmy/cmyactivity/activityRecruitsDetail/register', //批量签到
    exportExcel:'/cmy/cmyactivity/activityRecruitsDetail/exportExcel' //导出Excel表格

}